/**
 * The one place that decides whether a session counts as "signed in" for
 * routing.
 *
 * The public B2C order form (`/order`) signs a guest in ANONYMOUSLY so the
 * order endpoint stays authenticated. That session is not an account: it has
 * no role, no portal and nothing to show. Treating it as a signed-in user sent
 * the guest from `/login` (and from every protected route) to `/no-access`,
 * so a B2C client who had just ordered could not sign in in the same browser.
 *
 * Login and the route guards ask this, never `!!user`, so an anonymous guest
 * is shown the sign-in form and signing in replaces the anonymous session.
 */

import type { AuthUser } from './AuthContext';

export function isSignedIn(user: AuthUser | null | undefined): user is AuthUser {
  return !!user && !user.isAnonymous;
}
